export const ENV = window.location.hostname.includes('homologacao')
  ? 'homologation'
  : process.env.NODE_ENV;

export const NO_BREAK_SPACE = '\u00A0';

export const empty = <const>{
  array: Object.seal<never[]>([]),
  object: Object.seal({}),
};

export const FILTER_DEBOUNCE_MILLISECONDS = 300;
export const FILTER_MINIMUM_CHARACTERS = 3;

export const situacaoParse = {
  em_andamento: { label: 'Em andamento', className: 'em-andamento' },
  finalizado: { label: 'Finalizado', className: 'finalizado' },
  aberto: { label: 'Aberto', className: 'aberto' },
} as const;
